import { useEffect, useRef } from 'react';
import { Route, Routes, useLocation, useParams } from 'react-router-dom';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { useContract } from '@/hooks/api/use-contracts';
import { isWakamContract } from '@/lib/contracts';

import ChangeTiersPayeur from '@/pages/contract/change-tiers-payeur';
import Demenagement from '@/pages/contract/demenagement';
import AddFleet from '@/pages/contract/detail-contract/flotte/add-fleet';
import SortieVehicules from '@/pages/contract/detail-contract/flotte/sortie-vehicules';
import DetailContract from '@/pages/contract/detail-contract';
import FlotteDetail from '@/pages/contract/detail-contract/flotte-detail';
import Fractionnement from '@/pages/contract/fractionnement';
import GarantieMobilite from '@/pages/contract/garantie-mobilite';
import Hivernage from '@/pages/contract/hivernage';

const Contract = () => {
    const { id } = useParams();
    const { pathname } = useLocation();
    const contractQuery = useContract(id);
    const { refetch } = contractQuery;
    const contract = contractQuery.data;
    const isWakam = isWakamContract(contract);
    const isFleet = contract?.flotte;

    /* L'ancienne fiche relisait le contrat à chaque navigation sous /mes-contrats (retour sur la
       fiche après un avenant, une déclaration…) : on garde cette fraîcheur. */
    const isFirstPath = useRef(true);
    useEffect(() => {
        if (isFirstPath.current) {
            isFirstPath.current = false;
            return;
        }
        void refetch({ cancelRefetch: false });
    }, [pathname, refetch]);

    if (contractQuery.isPending) return <SmallSpinner />;
    if (!contract) return null;

    return (
        <Routes>
            <Route path={'/'} element={<DetailContract contract={contract} />} />
            {!isFleet && <Route path={'/mon-tiers-payeur'} element={<ChangeTiersPayeur contract={contract} />} />}
            {!isWakam && <Route path={'/je-demenage'} element={<Demenagement contract={contract} />} />}
            {!isFleet && <Route path={'/je-passe-en-prelevement'} element={<Fractionnement contract={contract} />} />}
            {!isWakam && !isFleet && <Route path={'/hivernage'} element={<Hivernage contract={contract} />} />}
            {!isFleet && <Route path={'/ma-garantie-mobilite'} element={<GarantieMobilite contract={contract} />} />}
            <Route path={'/sortie-vehicules'} element={<SortieVehicules contract={contract} />} />
            {isFleet && <Route path={'/ajout-vehicule'} element={<AddFleet contract={contract} />} />}
            <Route path={'/vehicule/:vehiculeId'} element={<FlotteDetail />} />
        </Routes>
    );
};

export default Contract;
